<template>
  <div>
    <base-header type="gradient-success" />
    <div class="container-fluid mt--6">
      <!-- card: locations -->
      <div class="card">
        <div class="card-header border-0">
          <!-- locations header -->
          <div class="row align-items-center mb-3">
            <div class="col">
              <h3 class="mb-0">Browse Locations</h3>
            </div>
            <div class="col-auto">
              <button class="btn btn-sm btn-primary" @click="openCreateModal">
                Create Location
              </button>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <base-input
                type="search"
                placeholder="filter by location name"
                input-classes="form-control-alternative fw-bold"
                v-model="keywords"
                class="mb-0"
              />
            </div>
          </div>
        </div>

        <!-- locations table -->
        <div class="table-responsive">
          <base-table thead-classes="thead-light" :data="filteredLocations">
            <template v-slot:columns>
              <th>Location Name</th>
              <th>Address</th>
              <th>Timezone</th>
              <th></th>
            </template>

            <template v-slot:default="row">
              <th scope="row">
                {{ row.item.name }}
              </th>
              <td>
                {{ row.item.address }}
              </td>
              <td>
                {{ row.item.timezone }}
              </td>
              <td>
                <a
                  href="#!"
                  @click.prevent="viewLocation(row.item)"
                  class="btn btn-sm btn-info"
                >
                  view
                </a>
              </td>
            </template>
          </base-table>
        </div>
      </div>

      <!-- Create Location Modal -->
      <modal :show="showCreateModal" @close="closeCreateModal">
        <template v-slot:header>
          <h5 class="modal-title">Create Location</h5>
        </template>
        <form @submit.prevent="createLocation">
          <div class="form-group">
            <label class="form-control-label">Name</label>
            <input
              type="text"
              v-model="createForm.name"
              class="form-control form-control-alternative"
              placeholder="Location name"
              required
            />
          </div>
          <div class="form-group">
            <label class="form-control-label">Address</label>
            <input
              type="text"
              v-model="createForm.address"
              class="form-control form-control-alternative"
              placeholder="Address"
              required
            />
          </div>
          <div class="form-group">
            <label class="form-control-label">Timezone</label>
            <select
              v-model="createForm.timezone"
              class="form-control form-control-alternative"
              required
            >
              <option value="">Select timezone</option>
              <option value="US/Eastern">Eastern (US/Eastern)</option>
              <option value="US/Central">Central (US/Central)</option>
              <option value="US/Mountain">Mountain (US/Mountain)</option>
              <option value="US/Pacific">Pacific (US/Pacific)</option>
              <option value="US/Alaska">Alaska (US/Alaska)</option>
              <option value="US/Hawaii">Hawaii (US/Hawaii)</option>
            </select>
          </div>
        </form>
        <template v-slot:footer>
          <button
            type="button"
            class="btn btn-secondary"
            @click="closeCreateModal"
            :disabled="isCreating"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="createLocation"
            :disabled="
              isCreating ||
              !createForm.name ||
              !createForm.address ||
              !createForm.timezone
            "
          >
            {{ isCreating ? "Creating..." : "Create Location" }}
          </button>
        </template>
      </modal>
    </div>
  </div>
</template>
<script>
import Modal from "@/components/Modal";

export default {
  components: {
    Modal,
  },
  data() {
    return {
      keywords: "",
      location: false,
      showCreateModal: false,
      isCreating: false,
      createForm: {
        name: "",
        address: "",
        timezone: "",
      },
    };
  },
  computed: {
    locations() {
      return this.$store.state.locations;
    },
    searchQuery() {
      return this.keywords.trim().toUpperCase();
    },
    filteredLocations() {
      if (this.searchQuery.length > 2) {
        return this.locations.filter(
          (l) => l.name.toUpperCase().indexOf(this.searchQuery) > -1
        );
      }
      return this.locations;
    },
  },
  methods: {
    viewLocation(location) {
      this.$router.push({
        name: "location",
        params: {
          locationId: location.locationId,
        },
      });
    },
    openCreateModal() {
      this.createForm = {
        name: "",
        address: "",
        timezone: "",
      };
      this.showCreateModal = true;
    },
    closeCreateModal() {
      this.showCreateModal = false;
    },
    async createLocation() {
      this.isCreating = true;
      try {
        const response = await this.$store.dispatch("callAPI", {
          action: "createLocation",
          location: {
            name: this.createForm.name,
            address: this.createForm.address,
            timezone: this.createForm.timezone,
          },
        });
        // Refresh locations list
        await this.$store.dispatch("fetchLocations");
        this.showCreateModal = false;
        // Navigate to the new location
        if (response.data.data && response.data.data.locationId) {
          this.$router.push({
            name: "location",
            params: {
              locationId: response.data.data.locationId,
            },
          });
        }
      } finally {
        this.isCreating = false;
      }
    },
  },
};
</script>

<style lang="scss"></style>
